import { Routes, Route, Navigate } from "react-router-dom";
import { useMe, RequireAuth, useAuthToken } from "@/lib/auth";
import { SignInPage, SignUpPage, ForgotPasswordPage, ResetPasswordPage } from "@/pages/Auth";
import AppLayout from "@/components/AppLayout";

import Landing from "@/pages/Landing";
import ApiDocs from "@/pages/ApiDocs";
// Admin
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminResellers from "@/pages/admin/Resellers";
import AdminResellerDetail from "@/pages/admin/ResellerDetail";
import AdminCustomers from "@/pages/admin/Customers";
import AdminBranding from "@/pages/admin/Branding";
import { FaviconSync } from "@/components/BrandMark";
import AdminProducts from "@/pages/admin/Products";
import AdminApprovals from "@/pages/admin/Approvals";
import AdminCommissions from "@/pages/admin/Commissions";
import AdminApiKeys from "@/pages/admin/ApiKeys";
import AdminSmtp from "@/pages/admin/Smtp";
// Reseller
import ResellerDashboard from "@/pages/reseller/Dashboard";
import ResellerProfile from "@/pages/reseller/Profile";
import ResellerDocuments from "@/pages/reseller/Documents";
import ResellerProducts from "@/pages/reseller/Products";
import ResellerCustomers from "@/pages/reseller/Customers";
import ResellerNewCustomer from "@/pages/reseller/NewCustomer";
import ResellerCommissions from "@/pages/reseller/Commissions";
import ResellerPlan from "@/pages/reseller/Plan";

function RoleHome() {
  const { data: me, isLoading } = useMe();
  if (isLoading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Caricamento…</div>;
  if (me?.user?.role === "admin") return <Navigate to="/admin" replace />;
  return <Navigate to="/portal" replace />;
}

function AdminOnly({ children }) {
  const { data: me, isLoading } = useMe();
  if (isLoading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Caricamento…</div>;
  if (me?.user?.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function Home() {
  const { token } = useAuthToken();
  return token ? <RoleHome /> : <Landing />;
}

function GuestOnly({ children }) {
  const { token } = useAuthToken();
  return token ? <Navigate to="/" replace /> : children;
}

export default function AppRoutes() {
  return (
    <>
    <FaviconSync />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/developer" element={<RequireAuth><AdminOnly><ApiDocs /></AdminOnly></RequireAuth>} />

      <Route path="/sign-in/*" element={<GuestOnly><SignInPage /></GuestOnly>} />
      <Route path="/sign-up/*" element={<SignUpPage />} />
      <Route path="/forgot-password" element={<GuestOnly><ForgotPasswordPage /></GuestOnly>} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      {/* Admin */}
      <Route path="/admin" element={<RequireAuth><AdminOnly><AppLayout /></AdminOnly></RequireAuth>}>
        <Route index element={<AdminDashboard />} />
        <Route path="resellers" element={<AdminResellers />} />
        <Route path="resellers/:id" element={<AdminResellerDetail />} />
        <Route path="customers" element={<AdminCustomers />} />
        <Route path="branding" element={<AdminBranding />} />
        <Route path="products" element={<AdminProducts />} />
        <Route path="approvals" element={<AdminApprovals />} />
        <Route path="commissions" element={<AdminCommissions />} />
        <Route path="api-keys" element={<AdminApiKeys />} />
        <Route path="smtp" element={<AdminSmtp />} />
      </Route>

      {/* Reseller */}
      <Route path="/portal" element={<RequireAuth><AppLayout /></RequireAuth>}>
        <Route index element={<ResellerDashboard />} />
        <Route path="profile" element={<ResellerProfile />} />
        <Route path="documents" element={<ResellerDocuments />} />
        <Route path="products" element={<ResellerProducts />} />
        <Route path="customers" element={<ResellerCustomers />} />
        <Route path="customers/new" element={<ResellerNewCustomer />} />
        <Route path="commissions" element={<ResellerCommissions />} />
        <Route path="plan" element={<ResellerPlan />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </>
  );
}
